import { Box, Divider, Skeleton } from "@mui/material";
import SkeletonList from "../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";

const DrawerSkeleton = () => {
    return (
        <Box>
            <SkeletonList mkey="DrawerSkeletonTitle" rows={0} rowsForCell={1} cols={1} useIcons iconCols={2} hasHeader />
            <Box sx={{ display: "flex", padding: 3, justifyContent: "space-between", alignItems: "flex-end" }}>
                <Skeleton variant="rectangular" width={200} height={200} />
                <Skeleton variant="rectangular" width={200} height={100} />
            </Box>
            <Divider />
            <Box>
                <SkeletonList mkey="DrawerSkeletonTabs" rows={1} rowsForCell={1} cols={2} />
                <SkeletonList mkey="DrawerSkeletonTab" rows={4} rowsForCell={1} cols={1} />
            </Box>
        </Box>
    )
}

export default DrawerSkeleton;